/**
 * @fileoverview Compliance Settings View - JS for the Compliance Settings page in Account Settings
 *
 * @author amywang@yext.com
 */
goog.module('yext.storm.ComplianceSettingsView');
goog.module.declareLegacyNamespace();

const DeIdentifiedReviewSettingsView = goog.require('yext.storm.DeIdentifiedReviewSettingsView');
const RemovedReviewSettingsView = goog.require('yext.storm.RemovedReviewSettingsView');
const SocialComplianceSettingsView = goog.require('yext.storm.SocialComplianceSettingsView');
const UgcSettingsView = goog.require('yext.storm.UgcSettingsView');

/**
 * @constructor
 */
const ComplianceSettingsView = function(options) {
  if (options.shouldShowSocialSettings) {
    /** @type {SocialComplianceSettingsView} */
    this.socialSettings = new SocialComplianceSettingsView().init();
  }

  if (options.shouldShowUgcSettings) {
    /** @type {UgcSettingsView} */
    this.ugcSettings = new UgcSettingsView().init();
  }

  if (options.shouldShowRemovedReviewSettings) {
    /** @type {RemovedReviewSettingsView} */
    this.removedReviewSettings = new RemovedReviewSettingsView().init();
  }

  if (options.shouldShowDeIdentifiedReviewSettings) {
    /** @type {DeIdentifiedReviewSettingsView} */
    this.deIdentifiedReviewSettings = new DeIdentifiedReviewSettingsView().init();
  }
};

goog.exportSymbol('yext.storm.ComplianceSettingsView', ComplianceSettingsView);

exports = ComplianceSettingsView;
